<form [formGroup]="backgroundForm">
    <p class="headline6">{{ 'registration.stepThree.background' | translate}}</p>
    <p class="subtitle3">{{ 'registration.stepThree.question1.question' | translate}}</p>

    <mat-radio-group *ngIf="!disable" aria-labelledby="radioGroupColumn"
        class="radioGroupColumn" formControlName="background" required>
        <mat-radio-button [disabled]="disable == true ? true : null" color="primary" class="example-radio-button"
            *ngFor="let background of backgrounds" [value]="background.name" [checked]="background.check">
            {{background.name}}
        </mat-radio-button>
    </mat-radio-group>
    <p class="body2" *ngIf="disable"> {{backgroundForm.value.background}} </p>

    <mat-divider></mat-divider>

    <p class="subtitle3">{{ 'registration.stepThree.question2' | translate}}</p>
    <mat-radio-group *ngIf="!disable" aria-labelledby="radioGroupRow"
        class="radioGroupRowWithMargin" formControlName="days" required>
        <mat-radio-button [disabled]="disable == true ? true : null" color="primary"
            class="radioButtonHorizontalHalfMargin" *ngFor="let day of days" [value]="day.number" [checked]="day.check">
            {{day.number}}
        </mat-radio-button>
    </mat-radio-group>
    <p class="body2" *ngIf="disable"> {{backgroundForm.value.days}} </p>

    <mat-divider></mat-divider>

    <p class="subtitle3">{{ 'registration.stepThree.question3' | translate}}</p>
    <mat-form-field *ngIf="!disable" appearance="fill" class="inputfullWidth">
        <mat-label>{{ 'registration.stepThree.genericAnswers.tellUs' | translate}}</mat-label>
        <textarea [readonly]="disable == true ? true : null" maxlength="250" id="trainingWeekInput"
            formControlName="trainingWeek" matInput required></textarea>
        <mat-hint align="end">{{backgroundForm.value.trainingWeek?.length || 0}} / 250</mat-hint>
    </mat-form-field>
    <p class="body2" *ngIf="disable"> {{backgroundForm.value.trainingWeek}} </p>

    <mat-divider></mat-divider>

    <p class="subtitle3">{{ 'registration.stepThree.question4' | translate}}</p>
    <mat-radio-group *ngIf="!isMobile && !disable" class="radioGroupRow" required formControlName="condition">
        <mat-radio-button [disabled]="disable == true ? true : null" *ngFor="let condition of conditions"
            color="primary" class="hideButton" [value]="condition">
            <label for="condition-button">
                <div class="flexInLineCenter">
                    <button class="buttonSmall" *ngIf="!condition.selected" (click)="saveCondition(condition)"
                        mat-stroked-button>{{condition.name}}</button>
                    <button class="buttonSmall2" *ngIf="condition.selected" color="primary"
                        (click)="saveCondition(condition)" mat-raised-button>{{condition.name}}</button>
                </div>
            </label>
        </mat-radio-button>
    </mat-radio-group>

    <div *ngIf="isMobile && !disable">
        <mat-radio-group *ngIf=" !disable" class="flexColumn" required formControlName="condition">
            <mat-radio-button [disabled]="disable == true ? true : null" *ngFor="let condition of conditions"
                color="primary" class="hideButton" [value]="condition">
                <label for="condition-button">
                    <button class="primaryButton3" *ngIf="!condition.selected" (click)="saveCondition(condition)"
                        mat-stroked-button>{{condition.name}}</button>
                    <button class="primaryButton3" *ngIf="condition.selected" color="primary"
                        (click)="saveCondition(condition)" mat-raised-button>{{condition.name}}</button>
                </label>
            </mat-radio-button>
        </mat-radio-group>

    </div>
    <p class="body2" *ngIf="disable">{{backgroundForm.value.condition}} </p>

    <br />
    <mat-divider></mat-divider>

    <p class="subtitle3">{{ 'registration.stepThree.question5' | translate}}</p>
    <mat-radio-group *ngIf="disable" [disabled]="disable == true ? true : null"
        aria-labelledby="radioGroupColumn" class="radioGroupColumn" required>

        <mat-radio-button *ngIf="!disable" [checked]="backgroundForm.value.complement != 'No'" color="primary" value="yes"
            (click)="changeComplements(true)">
            {{'registration.stepThree.genericAnswers.yes' | translate}}</mat-radio-button>

        <mat-form-field *ngIf="showComplements && !disable" appearance="fill" class="inputfullWidth">
            <mat-label>{{ 'registration.stepThree.workName' | translate}}</mat-label>
            <textarea [readonly]="disable == true ? true : null" maxlength="250" id="complementInput"
                formControlName="complement" matInput required></textarea>
            <mat-hint align="end">{{backgroundForm.value.complement?.length || 0}} / 250</mat-hint>
        </mat-form-field>
        <mat-radio-button *ngIf="!disable" color="primary" value="no" (click)="changeComplements(false)"
            [checked]="backgroundForm.value.complement == 'No'">
            {{'registration.stepThree.genericAnswers.no' | translate}}</mat-radio-button>
    </mat-radio-group>
    <p class="body2" *ngIf="disable">
        {{backgroundForm.value.complement ? backgroundForm.value.complement : 'No'}}
    </p>

    <mat-divider></mat-divider>

    <p class="subtitle3">{{ 'registration.stepThree.question6' | translate}}</p>
    <mat-form-field *ngIf="!disable" class="inputfullWidth">
        <mat-label>{{ 'registration.stepThree.genericAnswers.tellUs' | translate}}</mat-label>
        <textarea [readonly]="disable == true ? true : null" maxlength="250" id="restAndFoodInput"
            formControlName="restAndFood" matInput required></textarea>
        <mat-hint align="end">{{backgroundForm.value.restAndFood?.length || 0}} / 250</mat-hint>
    </mat-form-field>
    <p class="body2" *ngIf="disable"> {{backgroundForm.value.restAndFood}} </p>

    <mat-divider></mat-divider>

    <p class="subtitle3">{{ 'registration.stepThree.question7' | translate}}</p>
    <mat-form-field *ngIf="!disable" appearance="fill" class="inputfullWidth">
        <mat-label>{{ 'registration.stepThree.genericAnswers.tellUs' | translate}}</mat-label>
        <textarea [readonly]="disable == true ? true : null" maxlength="50" id="shoesInput" formControlName="shoes"
            matInput required></textarea>
        <mat-hint align="end">{{backgroundForm.value.shoes?.length || 0}} / 50</mat-hint>
    </mat-form-field>
    <p class="body2" *ngIf="disable"> {{backgroundForm.value.shoes}} </p>
</form>